export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken'
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refreshToken'
export const LOCAL_STORAGE_AGE_VERIFIED_KEY = 'age_verified'

export const useLocalStorageAccessToken = (): string => {
    const token =
        localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY) ??
        sessionStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)

    return token !== null ? JSON.parse(token) : ''
}

export const useLocalStorageSetAccessToken = (accessToken: string) => {
    // useLocalStorageClear()
    localStorage.setItem(
        LOCAL_STORAGE_ACCESS_TOKEN_KEY,
        JSON.stringify(accessToken)
    )
}

export const useSessionStorageSetAccessToken = (accessToken: string) => {
    useLocalStorageClear()
    sessionStorage.setItem(
        LOCAL_STORAGE_ACCESS_TOKEN_KEY,
        JSON.stringify(accessToken)
    )
}

export const useLocalStorageClear = () => {
    // Add any localStorage keys here that should survive logout.
    const preservedKeys = [
        LOCAL_STORAGE_AGE_VERIFIED_KEY,
    ]

    const preservedValues = preservedKeys.reduce<Record<string, string>>(
        (acc, key) => {
            const value = localStorage.getItem(key)

            if (value !== null) {
                acc[key] = value
            }

            return acc
        },
        {}
    )

    localStorage.clear()
    sessionStorage.clear()

    Object.entries(preservedValues).forEach(([key, value]) => {
        localStorage.setItem(key, value)
    })
}